module.exports = __webpack_public_path__ + "0.a0df4742b8e50a04a1ef.worker.js"